// 🔧 promotion_image_service.js
// ✅ Purpose: Business service for AI image generation in the LGV Promotion Engine
// ✅ Features:
// - Calls the secure Firebase Cloud Function
// - Generates AI images from Promotion Posts
// - Returns standardized image generation results
// - Keeps React pages unaware of backend implementation
// - Future-ready for asset library integration
// - Fully block-commented for clarity and future devs

import { httpsCallable } from "firebase/functions";

import { functions } from "../../firebase";

/**
 * ============================================================================
 * Firebase Callable
 * ============================================================================
 */

const generatePromotionImageCallable =
  httpsCallable(
    functions,
    "generatePromotionImage",
    {
      timeout: 9 * 60 * 1000,
    }
  );

/**
 * ============================================================================
 * generatePromotionImage
 * ============================================================================
 *
 * Generates an AI image for a Promotion Post.
 *
 * The backend determines:
 * - Prompt
 * - AI Provider
 * - Image Model
 * - Storage
 */
export const generatePromotionImage = async (
  request
) => {

  const response =
    await generatePromotionImageCallable(request);

  return {
    aiUsage: response.data.aiUsage,

    imageUrl:
      response.data.imageUrl,

    revisedPrompt:
      response.data.revisedPrompt,

    storagePath:
      response.data.storagePath || "",

    metadata:
      response.data.metadata,

  };

};
